import React, { memo } from 'react';

import style from './GameControlsWrapper.scss';
import { DemoButtonMobile } from '../../../Buttons';
import { PlayButton } from '../../../../../../../common/Game/Buttons';
import { useTranslations } from 'js/hooks/i18n';
import { clsx } from 'js/utils/classNames.util';

type GameControlsWrapperType = {
    hideButtons: boolean;
    funSupport: boolean;
    code: string;
    name: string;
    gameLaunchType: string;
    className?: string;
};

const GameControlsWrapper = ({
    hideButtons,
    funSupport,
    code,
    name,
    gameLaunchType,
    className = ''
}: GameControlsWrapperType) => {
    const translate = useTranslations('playtech.mobile.system.responsivegames.game.infoPopup.');

    return hideButtons ? null : (
        <div className={clsx([
            style.gameControlWrapper,
            className
        ])}>
            <PlayButton
                code={code}
                name={name}
                className={style.realPlay}
                gameLaunchType={gameLaunchType}
                ariaLabel={translate('aria-label.play')}
                isGameInfo
            />
            {funSupport && (
                <DemoButtonMobile
                    className={style.demo}
                    code={code}
                    name={name}
                    gameLaunchType={gameLaunchType}
                    ariaLabel={translate('aria-label.demo')}
                />
            )}
        </div>
    );
};

export default memo(GameControlsWrapper);
